import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirestoreRoomStateAI } from '../firestore/RoomStateAI/schema'
import { empty } from '../firestore/RoomStateAI/schema'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateAI extends ObservableModelWithDecorators<FirestoreRoomStateAI> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateAI>
  ) {
    super(repository, doc)
  }
}
